import { createMap, CropManagementOption, CroppingManagementOption, models } from "../../omnia"
import { IFieldsService } from "../../types"

export type CropManagementEditContext = ReturnType<typeof createCropManagementEditContext>

export const cropManagementLabels = {

    [models.RegionId.England]: {
        tab: "SFI",
        title: "SFI management options"
    },

    [models.RegionId.Scotland]: {
        tab: "AECS",
        title: "AECS management options"
    }

}

export function createCropManagementEditContext(
    svc: IFieldsService,
    readOnly: boolean,
    initialSelection: CroppingManagementOption[],
    getCurrentArea: () => number
) {

    const options = svc.getCropManagementOptions()
    const optionsMap = createMap(options, o => o.ManagementOptionId)
    const activeOptions = options.filter(o => !o.Inactive)

    let selection: CroppingManagementOption[] = initialSelection ?? []

    return {

        title: cropManagementLabels[svc.region]?.title,

        text: "",

        get activeOptions() {
            return activeOptions
        },

        get selection() {
            return selection
        },

        getOptionText,

        addOption(opt: CropManagementOption) {

            if (!opt) return
            if (readOnly) return

            if (selection.some(s => s.Id === opt.ManagementOptionId)) {
                this.text = ""
                return
            }

            selection.push({
                Id: opt.ManagementOptionId,
                Code: opt.Code,
                Area: undefined
            })

            this.text = ""

        },

        removeOption(opt: CroppingManagementOption) {
            if (readOnly) return
            selection.removeAll(o => o.Id === opt.Id)
        },

        validate

    }

    function getOptionText(opt: CroppingManagementOption) {
        if (!opt) return
        return optionsMap.get(opt.Id)?.Text
    }

    function validate() {
        const area = getCurrentArea()
        return selection.every(o => (o.Area ?? area) <= area)
    }
}
